import { render, staticRenderFns } from "./liveBackLook.vue?vue&type=template&id=2b1e8982&scoped=true&"
import script from "./liveBackLook.vue?vue&type=script&lang=js&"
export * from "./liveBackLook.vue?vue&type=script&lang=js&"
import style0 from "./liveBackLook.vue?vue&type=style&index=0&id=2b1e8982&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b1e8982",
  null
  
)

export default component.exports